import {
    CREATE_KNITTING_DC_DETAILS_FAILURE_DK,
    CREATE_KNITTING_DC_DETAILS_REQUEST_DK,
    CREATE_KNITTING_DC_DETAILS_SUCCESS_DK,
    CREATE_USER_FORM_KNITTING_DC_DETAILS_DK,
    DELETE_KNITTING_DC_DETAILS_FAILURE_DK,
    DELETE_KNITTING_DC_DETAILS_REQUEST_DK,
    DELETE_KNITTING_DC_DETAILS_SUCCESS_DK,
    FETCH_SINGLE_KNITTING_DC_DETAILS_FAILURE_DK,
    FETCH_SINGLE_KNITTING_DC_DETAILS_REQUEST_DK,
    FETCH_SINGLE_KNITTING_DC_DETAILS_SUCCESS_DK,
    FETCH_KNITTING_DC_DETAILS_FAILURE_DK,
    FETCH_KNITTING_DC_DETAILS_REQUEST_DK,
    FETCH_KNITTING_DC_DETAILS_SUCCESS_DK,
    KNITTING_DC_DETAILS_USERFORM_RESET_DK,
    UPDATE_KNITTING_DC_DETAILS_FAILURE_DK,
    UPDATE_KNITTING_DC_DETAILS_REQUEST_DK,
    UPDATE_KNITTING_DC_DETAILS_SUCCESS_DK,
    FETCH_KNITTING_DC_DETAILS_BY_ID_REQUEST_DK,
    FETCH_KNITTING_DC_DETAILS_BY_ID_SUCCESS_DK,
    FETCH_KNITTING_DC_PREVIOUS_LIST_REQUEST_DK,
    FETCH_KNITTING_DC_PREVIOUS_LIST_SUCCESS_DK,
    FETCH_KNITTING_DC_PREVIOUS_LIST_FAILURE_DK,
    FETCH_GRN_NO_BY_YARN_PO_REQUEST_DK,
    FETCH_GRN_NO_BY_YARN_PO_FAILURE_DK,
    FETCH_GRN_NO_BY_YARN_PO_SUCCESS_DK,
    FETCH_FABRIC_BY_YARN_PO_REQUEST_DK,
    FETCH_FABRIC_BY_YARN_PO_FAILURE_DK,
    FETCH_FABRIC_BY_YARN_PO_SUCCESS_DK
} from './knittingDCDetails.actionsType';

export const KNITTING_DC_DETAILS_DK = 'knittingDCDetailsDK';

let initialState = {
    loading: false,
    knittingDCDetailsById: [],
    knittingDCDetails: [],
    previousList: [],
    grnNoByYarnPO: [],
    fabricByYarnPO:[],
    userform: {
        fldRate: 0,
        fldQuantity: 0,
        fldGrossValue: 0,
        fldDiscountValue: 0,
        fldIGSTValue: 0,
        fldSGSTValue: 0,
        fldCGSTValue: 0,
        fldTaxableValue: 0,
        fldGSTValue: 0,
        fldSGSTPercentage: 0,
        fldCGSTPercentage: 0,
        fldIGSTPercentage: 0,
        fldFKBagWeight: 0,
        fldFKNoofBags: 0,
        fldPOQuantity: 0,
        fldInwardQuantity: 0,
        fldDiscountPercentage: 0,
        InwardNO: []
    },
    selectedKnittingDCDetails: {},
    errorMessage: '',
    iperrorMessage: ''
};

export let knittingDCDKDetailsReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;
    switch (type) {
        case FETCH_KNITTING_DC_DETAILS_REQUEST_DK:
        case FETCH_GRN_NO_BY_YARN_PO_REQUEST_DK:
        case FETCH_KNITTING_DC_PREVIOUS_LIST_REQUEST_DK:
        case FETCH_KNITTING_DC_DETAILS_BY_ID_REQUEST_DK:
        case CREATE_KNITTING_DC_DETAILS_REQUEST_DK:
        case FETCH_SINGLE_KNITTING_DC_DETAILS_REQUEST_DK:
        case UPDATE_KNITTING_DC_DETAILS_REQUEST_DK:
        case DELETE_KNITTING_DC_DETAILS_REQUEST_DK:
        case FETCH_KNITTING_DC_PREVIOUS_LIST_REQUEST_DK:
        case FETCH_FABRIC_BY_YARN_PO_REQUEST_DK:

            return {
                ...state,
                loading: true
            };
        case FETCH_KNITTING_DC_DETAILS_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                knittingDCDetails: updatePayload
            };
        case FETCH_GRN_NO_BY_YARN_PO_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                grnNoByYarnPO: updatePayload?.Inward
            };
            case FETCH_FABRIC_BY_YARN_PO_SUCCESS_DK:
                return {
                    ...state,
                    loading: false,
                    fabricByYarnPO: updatePayload
                };
        case FETCH_KNITTING_DC_PREVIOUS_LIST_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                previousList: updatePayload
            };
        case FETCH_KNITTING_DC_DETAILS_BY_ID_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                knittingDCDetailsById: updatePayload
            };

        case CREATE_KNITTING_DC_DETAILS_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                userform: {
                    fldRate: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldTaxableValue: 0,
                    fldGSTValue: 0,
                    fldSGSTPercentage: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    fldFKBagWeight: 0,
                    fldFKNoofBags: 0,
                    fldPOQuantity: 0,
                    fldInwardQuantity: 0,
                    fldDiscountPercentage: 0,
                    InwardNO: []
                },
                grnNoByYarnPO: []
            };
        case FETCH_SINGLE_KNITTING_DC_DETAILS_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                userform: updatePayload[0]
            };
        case UPDATE_KNITTING_DC_DETAILS_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                selectedKnittingDCDetails: {},
                userform: {
                    fldRate: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldTaxableValue: 0,
                    fldGSTValue: 0,
                    fldSGSTPercentage: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    fldFKBagWeight: 0,
                    fldFKNoofBags: 0,
                    fldPOQuantity: 0,
                    fldInwardQuantity: 0,
                    fldDiscountPercentage: 0,
                    InwardNO: []
                }
            };
        case DELETE_KNITTING_DC_DETAILS_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                userform: {
                    fldRate: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldTaxableValue: 0,
                    fldGSTValue: 0,
                    fldSGSTPercentage: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    fldFKBagWeight: 0,
                    fldFKNoofBags: 0,
                    fldPOQuantity: 0,
                    fldInwardQuantity: 0,
                    fldDiscountPercentage: 0,
                    InwardNO: []
                },
                selectedKnittingDCDetails: {}
            };

        case FETCH_KNITTING_DC_DETAILS_FAILURE_DK:
        case FETCH_GRN_NO_BY_YARN_PO_FAILURE_DK:
        case FETCH_KNITTING_DC_PREVIOUS_LIST_FAILURE_DK:
        case FETCH_SINGLE_KNITTING_DC_DETAILS_FAILURE_DK:
        case CREATE_KNITTING_DC_DETAILS_FAILURE_DK:
        case UPDATE_KNITTING_DC_DETAILS_FAILURE_DK:
        case DELETE_KNITTING_DC_DETAILS_FAILURE_DK:
        case FETCH_FABRIC_BY_YARN_PO_FAILURE_DK:

            return {
                ...state,
                loading: false,
                errorMessage: updatePayload
            };
        case CREATE_USER_FORM_KNITTING_DC_DETAILS_DK:
            return {
                ...state,
                loading: false,
                userform: {
                    ...state.userform,
                    [payload.key]: payload.value
                }
            };
        case KNITTING_DC_DETAILS_USERFORM_RESET_DK:
            return {
                ...state,
                userform: {
                    fldRate: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldTaxableValue: 0,
                    fldGSTValue: 0,
                    fldSGSTPercentage: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    fldFKBagWeight: 0,
                    fldFKNoofBags: 0,
                    fldPOQuantity: 0,
                    fldInwardQuantity: 0,
                    fldDiscountPercentage: 0,
                    InwardNO: []
                },
                selectedKnittingDCDetails: {}
            };
        default:
            return state;
    }
};
